import { Badge } from '@mantine/core';
import { verdictMeta } from './labels';

export interface CapacityBadgeProps {
  verdict: string;
  size?: string;
}

export const CapacityBadge = ({ verdict, size = 'sm' }: CapacityBadgeProps) => {
  const meta = verdictMeta(verdict);
  return (
    <Badge color={meta.color} variant="light" size={size}>
      {meta.label}
    </Badge>
  );
};
